import gql from 'graphql-tag'

import { AppRdvUpdateMessageAppointmentMutation } from '../../../types/api'

export default {
  mutation: gql`
    mutation AppRdvUpdateMessageAppointment($appointment: ID!, $message: String!) {
      rdvUpdateMessageAppointment(appointment: $appointment, message: $message) {
        id
        first_name
        last_name
        email
        slot {
          id
          opening_hour
          closing_hour
        }
      }
    }
  `,
  transformer: (response: AppRdvUpdateMessageAppointmentMutation) => {
    return response.rdvUpdateMessageAppointment
  },
}
